<template>
  <div>
    <v-card v-if="$store.state.showDetail" :style="{top: $store.state.detailTop}" class="order-item-detail">
      <v-snackbar top v-model="snackbar" :color="snackbarColor" timeout="2000">{{snackbarInfo}}</v-snackbar>

  <!--    <v-card width="580" height="310" v-if="$store.state.showCopyFile" style="background-color: #F2F2F2;z-index: 500">-->
  <!--      <div style="display: flex;margin: 14px 15px 5px;">-->
  <!--        <div class="title-font">下载</div>-->
  <!--        <v-spacer></v-spacer>-->
  <!--        <v-icon @click="closePanel">mdi-close</v-icon>-->
  <!--      </div>-->
  <!--      <div style="height: 1px;width: 550px;background-color: #DFDFDF; margin: 5px 15px;"></div>-->
  <!--      <div>-->
  <!--        <div class="title-span">-->
  <!--                <span>-->
  <!--                    {{$store.state.fileName}}-->
  <!--                </span>-->
  <!--          <span>-->
  <!--                    (可下载-->
  <!--                    <span style="color: red;font-weight: bold;">{{$store.state.fileNum}}</span>-->
  <!--                    个文件-->
  <!--                    <span v-if="!$store.state.isFolder">，-->
  <!--                        <span style="color: red;font-weight: bold;">{{size}}</span>{{unit}}-->
  <!--                    </span>)-->
  <!--                </span>-->
  <!--        </div>-->
  <!--        <div v-show="!noneFolderFile" style="margin-top: 20px;">-->
  <!--          <v-text-field solo v-model="url" style="font-size: 14px;margin: 0px 17px;"></v-text-field>-->
  <!--        </div>-->
  <!--        <div style="display: flex;justify-content: center;">-->
  <!--          <div v-if="url !== ''" style="display: flex;">-->
  <!--            <v-btn-->
  <!--              depressed :disabled="noneFolderFile" width="94" height="36" style="font-size: 12px;background-color: #7FA4FB;color: #FFFFFF;"-->
  <!--              v-clipboard:copy="url" v-clipboard:success="copySuccess" v-clipboard:error="copyError" @click="copyUrl"-->
  <!--            >复制</v-btn>-->
  <!--            <v-btn-->
  <!--              depressed v-if="$store.state.fileNum===1" @click="downloadFile"-->
  <!--              style="font-size: 12px;background-color: #7FA4FB;margin-left: 67px;color: #FFFFFF;" width="94" height="36"-->
  <!--            >立即下载</v-btn>-->
  <!--          </div>-->
  <!--          <div v-else>-->
  <!--            <span style="color:red">链接已过期，请联系商务经理</span>-->
  <!--          </div>-->
  <!--        </div>-->
  <!--        <div style="color: #888888;font-size: 12px;margin: 15px 20px;">-->
  <!--          对于整个<<b>文件夹</b>>下载，仅支持<b>复制下载链接</b>，可复制到<b>迅雷</b>等下载器中批量下载；对于<<b>单个文件</b>>下载，支持<b>复制下载链接</b>及<b>浏览器直接下载</b>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </v-card>-->

          <div>
              <div class="order-item-title">
                  <v-tabs v-model="$store.state.demandTabFunc" active-class="active-tab" slider-color="#333333">
                      <v-tab>订单详情</v-tab>
                      <v-tab v-if="showTab2">数据列表</v-tab>
                      <v-tab v-if="showTab3">数据列表</v-tab>
                      <v-tab v-if="$store.state.isTile">切片列表</v-tab>
                  </v-tabs>
                  <v-spacer></v-spacer>
                  <!-- 景ID筛选情况-->
                  <v-text-field v-if="$store.state.demandTabFunc === 1 && showTab2"
                      v-model="searchProductId" label="输入景ID，可用逗号隔开" style="width: 96%;margin-left: 200px" clearable
                      append-icon="mdi-magnify" @click:append="orderClick($store.state.orderId)"
                  ></v-text-field>

                  <v-icon @click="hidePanel">mdi-close</v-icon>
              </div>
              <div class="line-style"></div>
          </div>
          <v-tabs-items v-model="$store.state.demandTabFunc" class="order-item-detail-tab scrollbar">
              <v-tab-item>
                  <div v-if="!$store.state.hasOrderDetail" class="loading-demand-detail">
                      <v-card color="primary" dark width="410">
                          <v-card-text style="display: flex;flex-direction: column;">
                              <div style="margin-bottom: 5px;text-align: center">正在获取订单详情，请耐心等待</div>
                              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                          </v-card-text>
                      </v-card>
                  </div>
                  <DemandDetail v-else></DemandDetail>
              </v-tab-item>
              <v-tab-item v-if="showTab2">
                  <!--同样的代码-->
                  <div v-if="$store.state.deliveryDetail.deliveryInfos.length>0&&$store.state.deliveryDetail.deliveryInfos[0].packageOperation!=undefined&&$store.state.deliveryDetail.deliveryInfos[0].packageOperation==false">
                      <div class="order-item-content">
                          <div class="order-item-content-child">
                              <div style="width: 50%;display: flex;font-size: 12px;">
                                  <div class="product-label-title">文件名称：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].fileName}}</span> </div>
                              </div>
                          </div>
                          <div class="order-item-content-child">
                              <div style="width: 50%;display: flex;font-size: 12px;">
                                  <div class="product-label-title">文件大小：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].fileSize}}</span> </div>
                              </div>
                          </div>
                          <div class="order-item-content-child">
                              <div style="display: flex;font-size: 12px;">
                                  <div class="product-label-title">交付时间：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].finishTime}}</span> </div>
                              </div>
                          </div>
                        <div class="order-item-content-child">
                          <div style="display: flex;font-size: 12px;">
                            <div class="product-label-title">下载状态：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].isDownload}}</span> </div>
                          </div>
                        </div>
                      </div>
  <!--                    <div class="product-label-line">
                          <div style="width: 50%;display: flex;font-size: 12px;">
                              <div class="product-label-title">文件数量：<span style="color: #508CDD;">{{$store.state.deliveryDetail.deliveryInfos.length}}</span> 个</div>
                          </div>
                      </div>-->
                      <div class="order-item-content">
                          我们为您提供了大客户专属的对象存储服务（Object Storage Service，OBS），保障数据的海量、安全、高可靠存储。操作步骤如下：
                      </div>
                      <div class="order-item-content">1、下载并安装OBS Browser+工具；</div>
                      <div style="display: flex;margin-left: 16px;height: 18px;">
                          <a
                                  class="handbook-download-item"
                                  href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win32/OBSBrowserPlus-HEC-win32.zip"
                          >windows32位下载</a>|
                          <a
                                  class="handbook-download-item"
                                  href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win64/OBSBrowserPlus-HEC-win64.zip"
                          >windows64位下载</a>|
                          <a
                                  class="handbook-download-item"
                                  href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/mac/OBSBrowserPlus-HEC-mac64.zip"
                          >mac版本下载</a>
                      </div>
                      <div class="order-item-content">
                          <span>2、在OBS Browser+登录页选择授权码登录，复制以下授权码；</span>
                          <div style="float: right;color: #4C9DF2;cursor: pointer;margin-left: 240px;"
                               v-clipboard:copy="$store.state.user.authorizationCode" v-clipboard:success="copySuccess" v-clipboard:error="copyError"
                          >点击复制授权码</div>
                      </div>
                      <div class="handbook-auth-code scrollbar"><div class="handbook-auth-code-ellipsis">{{ $store.state.user.authorizationCode }}</div></div>
                      <div class="order-item-content">3、您的专属提取码为<span style="color: #8C8C8C;">{{ $store.state.user.obsKey }}</span>；</div>
                      <div class="order-item-content">
                          4、点击登录后，进入您的专属存储目录，可根据本订单ID<span style="color: #8C8C8C;"> <{{$store.state.orderId }}> </span>搜索对应的交付文件夹；
                      </div>
                      <div class="order-item-content" style="margin-bottom: 0px;">5、选择所需数据进行下载。</div>
                  </div>
                  <div v-else>
                      <div class="product-label-line" style="position: sticky; top: 0; background-color: white; z-index: 2;">
                          <div style="width: 150%;display: flex;font-size: 12px;">
                              <div class="product-label-title">文件数量：<span style="color: #508CDD;">{{$store.state.deliveryDetail.deliveryInfos.length}}</span>个</div>
                              <div v-if="$store.state.deliveryDetail.dataDeleted" style="color: red;margin-left: 20px;font-weight: bold;">全部已过期</div>
                              <div v-else style="color: #4691DB;cursor: pointer;margin-left: 20px;font-weight: bold;width: 125px" @click="downloadAll">复制全部下载链接</div>
                              <div v-if="!$store.state.deliveryDetail.dataDeleted" style="color: #4691DB;cursor: pointer;margin-left: 20px;font-weight: bold;width: 125px" @click="downloadSelected">复制所选下载链接</div>

                              <div v-if="$store.state.record.encryption" style="margin-left: 85px;font-weight: bold;color: #c99319">如有分卷，请下载全部压缩包后再解压</div>
                              <div v-else style="margin-left: 180px;font-weight: bold;color: #c99319">如有分卷，请下载全部压缩包后再解压</div>
                              <div v-if="$store.state.record.encryption" style="margin-left: 20px;font-weight: bold;" >解压密码: 6666{{$store.state.record.password}}</div>
                            <!-- 新增：下载状态筛选（默认全部） -->
                            <div v-if="!allDownloadStatusIsNull" style="margin-left: 20px;margin-top: -3px;">
                              <svg width="16" height="16" viewBox="0 -6 24 24" fill="none" stroke="#333" stroke-width="2" style="margin-right: 3px;">
                                <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <select
                                v-model="filterStatus"
                                @change="handleFilterChange"
                                style="padding: 2px 2px; outline: 2px;"
                              >
                                <option value="all">全部状态</option>
                                <option value="downloaded">已下载</option>
                                <option value="undownloaded">未下载</option>
                              </select>
                            </div>
                          </div>
                      </div>
                      <v-data-table
                        :key="refreshKey"
                              hide-default-footer disable-sort style="font-size: 22px;color: #919191;"
                              :items-per-page.sync="$store.state.deliveryDetail.deliveryInfos.length" v-model="selectedUrl" item-key="fileName"
                              :headers="deliveryHeader" :items="filteredDeliveryInfos" no-data-text="暂无匹配数据" show-select
                      >
                          <template v-slot:item.actions="{ item }">
                              <div v-if="$store.state.deliveryDetail.dataDeleted" style="color: red;">已过期</div>
                              <div v-else style="color: #4C9DF2;cursor: pointer;" @click="download(item)">下载</div>
                          </template>
                      </v-data-table>
                  </div>
              </v-tab-item>

              <v-tab-item v-if="showTab3">
                <div v-if="$store.state.deliveryDetail.deliveryInfos.length>0&&$store.state.deliveryDetail.deliveryInfos[0].packageOperation!=undefined&&$store.state.deliveryDetail.deliveryInfos[0].packageOperation==false">
                  <div class="order-item-content">
                    <div class="order-item-content-child">
                      <div style="width: 50%;display: flex;font-size: 12px;">
                        <div class="product-label-title">文件名称：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].fileName}}</span> </div>
                      </div>
                    </div>
                    <div class="order-item-content-child">
                      <div style="width: 50%;display: flex;font-size: 12px;">
                        <div class="product-label-title">文件大小：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].fileSize}}</span> </div>
                      </div>
                    </div>
                    <div class="order-item-content-child">
                      <div style="display: flex;font-size: 12px;">
                        <div class="product-label-title">交付时间：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].finishTime}}</span> </div>
                      </div>
                    </div>
                    <div class="order-item-content-child">
                      <div style="display: flex;font-size: 12px;">
                        <div class="product-label-title">下载状态：<span style="color: #101010;">{{$store.state.deliveryDetail.deliveryInfos[0].isDownload}}</span> </div>
                      </div>
                    </div>
                  </div>
                  <div class="order-item-content">
                    我们为您提供了大客户专属的对象存储服务（Object Storage Service，OBS），保障数据的海量、安全、高可靠存储。操作步骤如下：
                  </div>
                  <div class="order-item-content">1、下载并安装OBS Browser+工具；</div>
                  <div style="display: flex;margin-left: 16px;height: 18px;">
                    <a
                        class="handbook-download-item"
                        href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win32/OBSBrowserPlus-HEC-win32.zip"
                    >windows32位下载</a>|
                    <a
                        class="handbook-download-item"
                        href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win64/OBSBrowserPlus-HEC-win64.zip"
                    >windows64位下载</a>|
                    <a
                        class="handbook-download-item"
                        href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/mac/OBSBrowserPlus-HEC-mac64.zip"
                    >mac版本下载</a>
                  </div>
                  <div class="order-item-content">
                    <span>2、在OBS Browser+登录页选择授权码登录，复制以下授权码；</span>
                    <div
                        style="float: right;color: #4C9DF2;cursor: pointer;margin-left: 240px;"
                        v-clipboard:copy="$store.state.user.authorizationCode" v-clipboard:success="copySuccess" v-clipboard:error="copyError"
                    >点击复制授权码</div>
                  </div>
                  <div class="handbook-auth-code scrollbar"><div class="handbook-auth-code-ellipsis">{{ $store.state.user.authorizationCode }}</div></div>
                  <div class="order-item-content">3、您的专属提取码为<span style="color: #8C8C8C;">{{ $store.state.user.obsKey }}</span>；</div>
                  <div class="order-item-content">
                    4、点击登录后，进入您的专属存储目录，可根据本订单ID<span style="color: #8C8C8C;"> <{{$store.state.orderId }}> </span>搜索对应的交付文件夹；
                  </div>
                  <div class="order-item-content" style="margin-bottom: 0px;">5、选择所需数据进行下载。</div>
                </div>
                <div v-else>
                  <div class="product-label-line" style="position: sticky; top: 0; background-color: white; z-index: 2;">
                    <div style="width: 150%;display: flex;font-size: 12px;">
                      <div class="product-label-title">文件数量：<span style="color: #508CDD;">{{$store.state.deliveryDetail.deliveryInfos.length}}</span>个</div>
                      <div style="width: 100px">已选：<span style="color: #508CDD;">{{selectedUrl.length}}</span>个</div>
                      <div v-if="$store.state.deliveryDetail.dataDeleted" style="color: red;margin-left: 20px;font-weight: bold;">全部已过期</div>
                      <div v-else style="color: #4691DB;cursor: pointer;margin-left: 20px;font-weight: bold;width: 125px" @click="downloadAll">复制全部下载链接</div>
                      <div v-if="!$store.state.deliveryDetail.dataDeleted" style="color: #4691DB;cursor: pointer;margin-left: 20px;font-weight: bold;width: 125px" @click="downloadSelected">复制所选下载链接</div>
                      <div class="order-item-title" style="margin-left: 20px;font-weight: bold;">如有分卷，请下载全部压缩包后再解压</div>
                      <div v-if="$store.state.record.encryption" style="margin-left: 20px;font-weight: bold;" >解压密码: {{$store.state.record.password}}</div>
                    </div>
                  </div>
                  <!-- 按日期分组显示数据 -->
                  <div v-for="(files, date) in groupedDeliveryInfos" :key="date" class="date-group">
                    <div class="date-title" @click="toggleGroup(date)" style="display: flex; align-items: center; cursor: pointer;">
                      <span style="display: inline-block;transform: rotate(90deg); transition: transform 0.3s; margin-right: 8px;" v-if="openGroups[date]">{{ '>' }}</span>
                      <span v-else style="margin-right: 8px;">{{ '>' }}</span>
                      <v-checkbox
                          :input-value="isAllSelected(date)"
                          :indeterminate="isPartiallySelected(date)"
                          @change="toggleAllSelection(date)"
                          @click.stop
                          style="margin: 0 10px 0 0; padding: 0;"
                          hide-details
                          dense
                          color="primary"
                      />
                      <!-- 文本 -->
                      <span>启动交付时间： {{ files.date }}</span>
                    </div>
                    <v-data-table
                        v-show="openGroups[date]"
                        hide-default-footer
                        disable-sort
                        style="min-width: 660px; font-size: 12px; color: #919191;"
                        :items-per-page="files.items.length"
                        v-model="selectedUrl"
                        item-key="fileName"
                        :headers="deliveryHeader1"
                        :items="files.items"
                        no-data-text="暂无匹配数据"
                    >
                      <!-- 自定义列，用于显示行选择框 -->
                      <template v-slot:item.select="{ item }">
                        <input
                            type="checkbox"
                            v-model="selectedUrl"
                            :value="item"
                            @change="updateSelectAllState(date)"
                        />
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <div v-if="$store.state.deliveryDetail.dataDeleted" style="color: red;">已过期</div>
                        <div v-else style="color: #4C9DF2; cursor: pointer;" @click="download(item)">下载</div>
                      </template>
                    </v-data-table>
                  </div>
                </div>
              </v-tab-item>

            <!--            <v-tab-item v-if="$store.state.isTile&&tileState" style="width: 100%;">-->
                  <v-tab-item v-if="$store.state.isTile" style="width: 100%;">
                  <div class="product-label-line">
                      <div style="width: 50%;display: flex;">
                          <div class="product-label-title">切片数量：<span style="color: #508CDD;">1</span> 个</div>
                      </div>
                  </div>
                  <div class="layer-table-title">
                      <div style="margin: 12px 0px;">切片名称</div><div style="margin: 12px 0px;">切片状态</div>
                  </div>
                  <div class="layer-table-line">
                      <div class="layer-table-line-item">{{$store.state.deliveryDetail.productName}}</div>
                      <div class="layer-table-line-item">{{tileStateDict[$store.state.deliveryDetail.tileState]}}</div>
                  </div>
                  <TileDetail></TileDetail>
              </v-tab-item>
          </v-tabs-items>
      </v-card>
    <v-card
    width="580"
    height="310"
    v-if="$store.state.showCopyFile"
    style="background-color: #F2F2F2; z-index: 9999; position: fixed; top: 30%; left: 50%; transform: translate(-50%, -50%);"
  >
    <div style="display: flex;margin: 14px 15px 5px;">
      <div class="title-font">下载</div>
      <v-spacer></v-spacer>
      <v-icon @click="closePanel">mdi-close</v-icon>
    </div>
    <div style="height: 1px;width: 550px;background-color: #DFDFDF; margin: 5px 15px;"></div>
    <div>
      <div class="title-span">
                <span>
                    {{$store.state.fileName}}
                </span>
        <span>
                    (可下载
                    <span style="color: red;font-weight: bold;">{{$store.state.fileNum}}</span>
                    个文件
                    <span v-if="!$store.state.isFolder">，
                        <span style="color: red;font-weight: bold;">{{size}}</span>{{unit}}
                    </span>)
                </span>
      </div>
      <div v-show="!noneFolderFile" style="margin-top: 20px;">
        <v-text-field solo v-model="url" style="font-size: 14px;margin: 0px 17px;"></v-text-field>
      </div>
      <div style="display: flex;justify-content: center;">
        <div v-if="url !== ''" style="display: flex;">
          <v-btn
            depressed :disabled="noneFolderFile" width="94" height="36" style="font-size: 12px;background-color: #7FA4FB;color: #FFFFFF;"
            v-clipboard:copy="url" v-clipboard:success="copySuccess" v-clipboard:error="copyError" @click="copyUrl"
          >复制</v-btn>
          <v-btn
            depressed v-if="$store.state.fileNum===1" @click="downloadFile"
            style="font-size: 12px;background-color: #7FA4FB;margin-left: 67px;color: #FFFFFF;" width="94" height="36"
          >立即下载</v-btn>
        </div>
        <div v-else>
          <span style="color:red">链接已过期</span>
        </div>
      </div>
      <div style="color: #888888;font-size: 12px;margin: 15px 20px;">
        对于整个<<b>文件夹</b>>下载，仅支持<b>复制下载链接</b>，可复制到<b>迅雷</b>等下载器中批量下载；对于<<b>单个文件</b>>下载，支持<b>复制下载链接</b>及<b>浏览器直接下载</b>
      </div>
    </div>
  </v-card>
  </div>
</template>
<script>
    import DemandDetail from "./DemandDetail";
    import TileDetail from "./TileDetail";

    export default {
        name: "OrderItemDetail",
        data() {
            return {
              filterStatus: 'all',
              url: "",
              noneFolderFile: false,
              size: 0, unit: "",
              refreshKey: 0,
                groupStates: {},

                selectAll: {}, // 跟踪每个日期组的全选状态

                openGroups: {}, // 跟踪哪个日期组是展开的

                selectedUrl: [],

                searchProductId:'',

                snackbar: false, snackbarInfo: "", snackbarColor: "",
                orderId: "",  // 大客户的订单ID
                authorizationCode: "https://e-share.obs-website.cn-north-1.myhuaweicloud.com?token=fVpi5/GRrUU3gS2TZOrT2pVyx/iVJtyAc1VTkVLed4EkoBuFYEBsrgEzUxcOXR/4nu9ZzyvUlmj41kAGmPRwfCwPOdjcNwkFqOAUwhNY41kTklHiYZcerWHKM0gboOya5SO0ooE9Z+GIfXvEoWt+cIVOLJt3n5zhzBaTL/xw8PpTBxE8nMA4S+6PddSrU/MrwE2Feg68Ivb9UbQ9qNzT1qJ6yYjFQgwnOt40GKF+tfD9Sd606jUuqt8y1WxUmMaRf4IKzN67xVfh5AjB4VNuL/2avwsNPKK2qU26HLj1kO0cUFh5aEiyjvTvwmw43LnVIDNOP3JV3x0J4nMOnbwH2gl3vV6pn22HZRy4NbDHztMT6xb4MddLGSKOcUSAinuLHkT1xJY10Sv9nsWIahI5YoOSpvaUSFt0DLhytjFRxCNW2xAa4Wr3V6waA2TM7vOIJ2hoU90NhhRUXUcBmhOSWh/DT4uy2S/fpmsQ6jCJ1IIUqVnuusAU6EKpWJxOqlqOk6SoLX87rPq/0hjmQfMFdfbfv5kUxTf097fUAUA8iNgCJz57Xow4bCOcp7zx5gNUQ3SZ16WSA28hkElWhN/gGNSwzRDk1bPmj2uHLy3M4fo=",
                tileStateDict: {
                    "-1": "未准备好", "0": "初始状态", "1": "正在切片", "2": "切片完成", "3": "创建失败"
                },

                showDialog: false,
                productIdListMatch: [],
                productIdListUnMatch: []

            }
        },
        computed: {

          // 判断是否所有 deliveryInfos 的 isDownload 都是 null
          allDownloadStatusIsNull() {
            const deliveryInfos = this.$store.state.deliveryDetail.deliveryInfos || [];
            return deliveryInfos.length > 0 && deliveryInfos.every(item => 
              item.isDownload === null || item.isDownload === undefined
            );
          },

          // 动态生成 deliveryHeader
          deliveryHeader() {
            const headers = [
              { text: '文件名称', align: 'center', value: 'fileName', width: "200px" },
              { text: '文件大小', align: 'center', value: 'fileSize', width: "80px" },
              { text: '交付时间', align: 'center', value: 'finishTime', width: "140px" },
            ];
            if (!this.allDownloadStatusIsNull) {
              headers.push({ text: '下载状态', align: 'center', value: 'isDownload', width: "80px" });
            }
            headers.push({ text: '操作', align: 'center', value: 'actions', width: "60px" });
            return headers;
          },

          // 动态生成 deliveryHeader1
          deliveryHeader1() {
            const headers = [
              { text: '', value: 'select', sortable: false, width: "20px" },
              { text: '文件名称', align: 'left', value: 'fileName', width: "200px" },
              { text: '文件大小', align: 'center', value: 'fileSize', width: "80px" },
              { text: '交付时间', align: 'center', value: 'finishTime', width: "140px" },
            ];
            if (!this.allDownloadStatusIsNull) {
              headers.push({ text: '下载状态', align: 'center', value: 'isDownload', width: "80px" });
            }
            headers.push({ text: '操作', align: 'center', value: 'actions', width: "60px" });
            return headers;
          },

          // 筛选后的文件列表
          filteredDeliveryInfos() {
            const list = this.$store.state.deliveryDetail.deliveryInfos || [];
            const status = this.filterStatus;

            if (status === 'downloaded') {
              return list.filter(item => item.isDownload === '已下载');
            } else if (status === 'undownloaded') {
              return list.filter(item => item.isDownload === '未下载');
            }
            // 默认全部
            return list;
          },

            // 自动生成组状态
            computedGroupStates() {
              Object.keys(this.groupedDeliveryInfos).forEach(date => {
                const group = this.groupedDeliveryInfos[date]
                const selectedCount = group.filter(f => f.selected).length
                this.$set(this.groupStates, date, {
                  checked: selectedCount === group.length,
                  indeterminate: selectedCount > 0 && selectedCount < group.length
                })
              })
              return this.groupStates
            },

            isAllSelected() {
              console.log("进入这里1")
              return (date) => {
                const files = this.groupedDeliveryInfos[date].items;
                return files.every((file) => this.selectedUrl.includes(file));
              };
            },
            isPartiallySelected() {
              return (date) => {
                const files = this.groupedDeliveryInfos[date].items;
                console.log(files)
                if (!files || files.length === 0) return false; // 确保文件列表不为空
                const someSelected = files.some((file) => this.selectedUrl.includes(file));
                const notAllSelected = files.some((file) => !this.selectedUrl.includes(file));
                return someSelected && notAllSelected;
                // return true
              };
            },

            groupedDeliveryInfos() {
              const deliveryInfos = this.$store.state.deliveryDetail.largeAreaDeliveryInfos;
              const groupedData = {};
              const groupedDate = Object.keys(this.$store.state.deliveryDetail.largeAreaDeliveryInfos)
              groupedDate.forEach(item => {
                const date = item;

                for (let record of deliveryInfos[date]){
                  if (record.fileSize >= 1073741824) {
                    record.fileSize = (record.fileSize/1073741824).toFixed(2) + "GB";
                  } else if (record.fileSize >= 1048576) {
                    record.fileSize = (record.fileSize/1048576).toFixed(2) + "MB";
                  } else if (record.fileSize >= 1024) {
                    record.fileSize = (record.fileSize/1024).toFixed(2) + "KB";
                  } else {
                    record.fileSize = record.fileSize + "B";
                  }
                  record.finishTime = record.finishTime.substring(0,19)
                }

                groupedData[date] = deliveryInfos[date];
              });

              return Object.keys(groupedData).map(date => ({
                date,
                items: groupedData[date]
              }));
            },
            totalFilesCount() {
              return this.$store.state.deliveryDetail.deliveryInfos.length;
            },

            showTab3: function () {
              console.log(Object.keys(this.$store.state.deliveryDetail.largeAreaDeliveryInfos).length > 0)
              if (this.$store.state.deliveryDetail.hasOwnProperty("largeAreaDeliveryInfos") && Object.keys(this.$store.state.deliveryDetail.largeAreaDeliveryInfos).length > 0) {
                this.selectedUrl = []
                return true;
              } else {
                return false;
              }
            },
            showTab2: function () {
                if (this.$store.state.deliveryDetail.hasOwnProperty("deliveryInfos") && this.$store.state.deliveryDetail.deliveryInfos.length!==0) {
                    this.selectedUrl = []
                    return true;
                } else {
                    return false;
                }
            },



            tileState: function () {
                let allowedState = [ 1, 2, -1 ];
                //alert(this.$store.state.deliveryDetail.tileState)
                if (allowedState.includes(this.$store.state.deliveryDetail.tileState)) {
                    //alert("aaa")
                    return true;
                } else {
                    //alert("bbb")
                    return false;
                }
            },

        },

        watch:{
          "$store.state.deliveryDetail.deliveryInfos":{
            handler: function () {
              this.searchProductId = ''
            }
          },
        },
        components: {
            TileDetail,
            DemandDetail,
        },

        methods: {

          handleFilterChange() {
            // 这里写你筛选列表的逻辑
            console.log('当前筛选状态：', this.filterStatus);

            // 示例：根据 filterStatus 过滤 deliveryInfos 数组
            // this.filteredList = this.$store.state.deliveryDetail.deliveryInfos.filter(item => {
            //   if (this.filterStatus === 'downloaded') return item.downloaded === true;
            //   if (this.filterStatus === 'undownloaded') return item.downloaded === false;
            //   return true;
            // });
          },

            updateSelectAllState(date) {
              const files = this.groupedDeliveryInfos[date].items;
              const allSelected = files.every((file) => this.selectedUrl.includes(file));
              const noneSelected = files.every((file) => !this.selectedUrl.includes(file));

              if (allSelected) {
                this.selectAll[date] = true;
              } else if (noneSelected) {
                this.selectAll[date] = false;
              } else {
                this.selectAll[date] = 'xxx'; // 部分选中状态
              }

            },

            toggleAllSelection(date) {
              const files = this.groupedDeliveryInfos[date].items;
              if (this.isAllSelected(date)) {
                // 取消全选
                this.selectedUrl = this.selectedUrl.filter((item) => !files.includes(item));
              } else {
                // 全选
                this.selectedUrl = [...new Set([...this.selectedUrl, ...files])];
              }
            },

            toggleGroup(date) {
              // 如果日期不在 openGroups 中，则默认设置为 false（即关闭）
              if (this.openGroups[date] === undefined) {
                this.$set(this.openGroups, date, false);
              }
              // 切换打开/关闭状态
              this.openGroups[date] = !this.openGroups[date];
            },


            orderClick(orderId){
              //打接口获取筛选结果
              if (this.searchProductId && typeof this.searchProductId === 'string') {
                const processedParams = this.searchProductId
                    .replace(/[\uff0c\u3001\r\n;，；]/g, ',')
                    .replace(/\s+/g, '')
                    .split(',')
                    .filter(Boolean)
                    .join(',');

                if (!processedParams) {
                  alert('请输入有效的产品名称');
                  return;
                }

                this.axios({
                  method: 'get',
                  url: '/demandService/pan/matchDemandDeliveries',
                  params: {
                    demandId: orderId,
                    productNames: processedParams
                  }
                }).then(response => {

                  if (response.data.message === 'success'){

                    this.selectedUrl = []

                    let filterResult = response.data.data.deliveryInfos

                    for (const delivery of filterResult) {
                      delivery["metaFileSize"] = delivery.fileSize;
                      // 处理“数据列表”的表格中“文件大小”的展示数据
                      if (delivery.fileSize >= 1073741824) {
                        delivery.fileSize = (delivery.fileSize/1073741824).toFixed(2) + "GB";
                      } else if (delivery.fileSize >= 1048576) {
                        delivery.fileSize = (delivery.fileSize/1048576).toFixed(2) + "MB";
                      } else if (delivery.fileSize >= 1024) {
                        delivery.fileSize = (delivery.fileSize/1024).toFixed(2) + "KB";
                      } else {
                        delivery.fileSize = delivery.fileSize + "B";
                      }
                      delivery.finishTime = delivery.finishTime.slice(0, 19);
                      
                      // 处理 isDownload 状态
                      const downloadStatus = delivery.isDownload;
                      if (downloadStatus === null || downloadStatus === undefined) {
                        delivery.isDownload = null;
                      } else if (downloadStatus === true) {
                        delivery.isDownload = '已下载';
                      } else if (downloadStatus === false) {
                        delivery.isDownload = '未下载';
                      } else {
                        delivery.isDownload = downloadStatus;
                      }
                    }

                    this.$store.state.deliveryDetail.deliveryInfos = filterResult
                    this.$forceUpdate()
                  }
                })

              }
            },

            hidePanel(){
                this.$store.state.showDetail = false;
                this.$store.state.record = {};
                this.searchProductId = ''
                this.showDialog = false
            },
            downloadAll(){
                this.$store.state.isFolder = true;
                this.$store.state.fileName = this.$store.state.deliveryDetail.requestName;
                this.$store.state.fileNum = 0;
                this.$store.state.fileLink = [];
                this.selectedUrl = []
                for (let i = 0; i < this.$store.state.deliveryDetail.deliveryInfos.length; i++) {
                    this.$store.state.fileNum += 1;
                    this.$store.state.fileLink.push(this.$store.state.deliveryDetail.deliveryInfos[i].url);
                    this.selectedUrl.push(this.$store.state.deliveryDetail.deliveryInfos[i])
                }
                this.url = this.$store.state.fileLink.join("\n");
                this.$store.state.showCopyFile = true;
            },

            downloadSelected(){
              this.$store.state.isFolder = true;
              this.$store.state.fileName = this.$store.state.deliveryDetail.requestName;
              this.$store.state.fileNum = 0;
              this.$store.state.fileLink = [];
              for (let i = 0; i < this.selectedUrl.length; i++) {
                this.$store.state.fileNum += 1;
                this.$store.state.fileLink.push(this.selectedUrl[i].url);
              }
              this.url = this.$store.state.fileLink.join("\n");
              this.$store.state.showCopyFile = true;
            },

            download(item){
                this.$store.state.fileLink = [item.url];
                this.$store.state.item = item
                this.$store.state.isFolder = false;
                this.$store.state.fileName = item.fileName;
                this.$store.state.fileNum = 1;
                this.$store.state.fileSize = item.metaFileSize;
                this.url = this.$store.state.fileLink.join("\n");

                this.$store.state.showCopyFile = true;
            },
            copySuccess() {
                this.snackbarColor="success"
                this.snackbarInfo = "已复制到剪切板"
                this.snackbar = true;
            },
            copyError() {
                this.snackbarColor="error"
                this.snackbarInfo = "复制失败"
                this.snackbar = true;
            },

          downloadFile(){
            let link = document.createElement('a')
            link.setAttribute('download', '')
            link.href = this.url;
            link.click();
            let item = this.$store.state.item;
            // 只有当原来的 isDownload 不是 null/undefined 时才更新状态
            if (item.isDownload !== null && item.isDownload !== undefined) {
              this.updateDownloadStatus(item);
              this.$set(item, 'isDownload', '已下载')
              this.refreshKey++
            }
          },

          copyUrl() {
            if (this.selectedUrl && this.selectedUrl.length > 0) {
              for (let i = 0; i < this.selectedUrl.length; i++) {
                const item = this.selectedUrl[i];
                // 只有当原来的 isDownload 不是 null/undefined 时才更新状态
                if (item.isDownload !== null && item.isDownload !== undefined) {
                  this.updateDownloadStatus(item);
                  this.$set(item, 'isDownload', '已下载')
                  this.refreshKey++
                }
              }
            } else {
              let item = this.$store.state.item;
              // 只有当原来的 isDownload 不是 null/undefined 时才更新状态
              if (item.isDownload !== null && item.isDownload !== undefined) {
                this.updateDownloadStatus(item);
                this.$set(item, 'isDownload', '已下载')
                this.refreshKey++
              }
            }
          },

          updateDownloadStatus(item) {
            var param = new FormData();
            param.append("productCode", item.productCode);
            this.axios.get("/demandService/pan/downloadSyn?productCode="+item.productCode)
              .then(function (res) {
                console.log("接口返回成功" + res);
              });
          },

          cleanData(){
            if (!this.$store.state.isFolder) {
              // 压缩包
              this.noneFolderFile = false;
              if (this.$store.state.fileSize >= 1000000000) {
                this.size = (this.$store.state.fileSize/1000000000).toFixed(2);
                this.unit = "GB";
              } else if (this.$store.state.fileSize >= 1000000) {
                this.size = (this.$store.state.fileSize/1000000).toFixed(2);
                this.unit = "MB";
              } else if (this.$store.state.fileSize >= 1000) {
                this.size = (this.$store.state.fileSize/1000).toFixed(2);
                this.unit = "KB";
              } else{
                this.size = this.$store.state.fileSize;
                this.unit = "B";
              }
            } else {
              if (this.$store.state.fileNum === 0){
                this.noneFolderFile = true;
              } else {
                this.noneFolderFile = false;
              }
            }
          },
          closePanel(){
            this.$store.state.showCopyFile = false;
            this.$store.state.fileNum = 0;
            this.$store.state.fileLink = [];
            this.$store.state.isFolder = false;
            this.$store.state.fileName = "";
            this.$store.state.fileSize = 0;
            this.$store.state.showOriginImage = false;
            this.$store.state.bifProductId = "";
            this.$store.state.isDownloadUrl = false;
          }
        },
        mounted() {
          this.searchProductId = ''
          this.showDialog = false
        },
    }
</script>
<style scoped>

    .order-item-detail{
        position: absolute;
        width: 1000px;
        height: 575px;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .order-item-title {
        position: relative;
        width: 900px;
        display: flex;
        align-items: center;
        color: #919191;
    }
    .line-style {
        height: 1px;
        width: 900px;
        background-color: #DFDFDF;
        margin: 5px 15px;
    }
    .active-tab {
        font-weight: bold;
        color: #575757;
    }
    .product-label-line {
        display: flex;
        width: 250%;
        margin: 17px 8px 8px 8px;
    }
    .product-label-line1 {
        display: flex;
        width: 100%;
        margin: 7px 8px 8px 8px;
    }
    .product-label-title {
        color: #818181;
        font-size: 12px;
        width: 120px;
    }
    .layer-table-title {
        width: 100%;
        height: 45px;
        background-color: #F8FAFF;
        font-size: 12px;
        font-weight: bold;
        display: flex;
        justify-content: space-around;
    }
    .layer-table-line {
        width: 100%;
        height: 45px;
        font-size: 12px;
        color: #868686;
        font-size: 12px;
        display: flex;
        justify-content: space-around;
    }
    .layer-table-line-item {
        width: 50%;
        display: flex;
        justify-content: center;
        margin: 12px 0px;
    }
    .order-item-detail-tab {
        overflow-y: auto;
        width: 100%;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
    }
    .handbook-label {
        font-size: 12px;
        color: #101010;
        margin: 14px 8px;
    }
    .handbook-download-item {
        font-size: 12px;
        color: #8C8C8C;
        margin: 0px 12px;
        padding: 1px 0px;
        text-decoration: none;
    }
    .handbook-download-item:hover {
        color: #4C9DF2;
        text-decoration: underline;
    }
    .handbook-auth-code {
        padding: 8px 10px;
        margin: 0px 8px;
        width: 690px;
        height: 176px;
        line-height: 20px;
        border-radius: 3px;
        border: 1px solid #BBBBBB;
        font-size: 10px;
        color: #8C8C8C;
    }
    .handbook-auth-code-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
    .loading-demand-detail {
        display: flex;
        justify-content: center;
        margin-top: 180px;
    }
    .order-item-content {
        width: 700px;
        padding: 10px 20px 5px 15px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 12px;
    }
    .order-item-content-child {
        width: 50%;
        margin: 5px 0px;
    }

    .date-group {
      margin-bottom: 10px;
      width: 104%;
      transform: translateX(-2%);
    }

    .date-group input[type="checkbox"] {
      margin-left: 5px;
      transform: scale(110%) translateY(10%);
    }

    .date-title {
      font-size: 14px;
      font-weight: bold;
      color: #919191;
      cursor: pointer;
      padding: 10px;
      background-color: #f8f8f8;
      border: 1px solid #ddd;
    }

    .date-title:hover {
      background-color: #eaeaea;
    }
    .date-title input[type="checkbox"] {
      margin-right: 5px;
      transform: scale(110%) translateY(10%);
    }


    ::v-deep th {
      padding: 0 8px !important; /* 保持表头与数据行相同的 padding */
    }

    ::v-deep td {
      padding: 0 8px !important;
    }

    .title-font {
      font-size: 14px;
      color: #101010;
    }

    .title-span {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      margin-top: 10px;
      font-size: 14px;
      color: #4B4B4B;
    }

</style>